"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/button/button";
import LogoutBoxLineIcon from "remixicon-react/LogoutBoxLineIcon";
import fetcher from "@/lib/fetcher";
import useUserStore from "@/global-store/user";
import useCartStore from "@/global-store/cart";
import { clearLoginCookie } from "@/utils/auth-cookie";
import { clearAppCartStorage } from "@/utils/clear-app-cart";

const LogoutButton = () => {
  const [loading, setLoading] = useState(false);
  const signOut = useUserStore((state) => state.signOut);
  const clearCart = useCartStore((state) => state.clear);
  const deleteMemberData = useCartStore((state) => state.deleteMemberData);
  const router = useRouter();

  const handleLogout = async () => {
    setLoading(true);
    try {
      await fetcher.post("users/auth/logout", { body: {} });
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      clearCart();
      deleteMemberData();
      clearAppCartStorage();
      if (typeof window !== "undefined") {
        window.localStorage.removeItem("cart");
      }
      signOut();
      clearLoginCookie();
      router.push("/signin");
    }
  };

  return (
    <Button
      color="primary"
      className="!px-6 !py-2 !h-auto !text-base rounded-xl"
      leftIcon={<LogoutBoxLineIcon size={18} />}
      loading={loading}
      disabled={loading}
      onClick={handleLogout}
    >
      Logout
    </Button>
  );
};

export default LogoutButton;
